<template>

  <div class="soundtrack_header"></div>  <!-- top background image -->
  <div class="soundtrack_top"></div>  <!-- top image -->
  <div class="soundtrack_mid_image"></div> <!-- middle image -->
  <div class="soundtrack_bottom_image"></div>  <!-- bottom image -->

</template>

<style>


.soundtrack_header{
  position: relative;
  /* border: 1px solid rgb(13, 0, 255); */
  background-image: url('../assets/Sora.jpg');
  background-size:cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: auto;
  padding-top: 0;
  padding-bottom:28%;
  margin-top: 0;
  margin-bottom: 10vh;
}


.soundtrack_top{
  position: relative;
  /* border: 2px solid rgb(13, 0, 255); */
  background-image: url('../assets/Stillpic1.jpg');
  background-size:contain;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 114px;
  max-height:229px;
  width: auto;

  padding-top: 5vh;
  padding-bottom:5vh ;
  margin-top: 5vh;
  margin-bottom: 10vh;
}

.soundtrack_mid_image{
  position: relative;
  /* border: 2px solid rgb(13, 0, 255); */
  
  background-image: url('../assets/Stillpic2.jpg');
  background-size:contain;
  background-repeat: no-repeat;
  background-position: center;
  min-height:114px;
  max-height:229px;
  width: auto;
  height: auto;
  max-width: 100%; 
  padding-top: 5vh;
  padding-bottom:5vh ;
  margin-top: 5vh;
  margin-bottom: 10vh;
}

.soundtrack_bottom_image{
  position: relative;
  /* border: 2px solid rgb(13, 0, 255); */
  background-image: url('../assets/Stillpic3.jpg');
  background-size:contain;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 114px;
  max-height:229px;
  width: auto;
  height: auto;
  padding-top: 5vh;
  padding-bottom:5vh ;
  margin-top: 5vh;
  margin-bottom: 10vh;
}

</style>